import { useLocation } from "react-router-dom";

/*
 * MovingOrb — soft glowing orb that drifts across the viewport. Full
 * intensity on the landing; toned down on every other route so it doesn't
 * compete with content.
 */
export default function MovingOrb() {
  const { pathname } = useLocation();
  // Hide on admin routes — back-office should be clean and functional.
  if (pathname.startsWith("/admin")) return null;
  const intense = pathname === "/";
  return (
    <div className={`orb-stage ${intense ? "" : "orb-soft"}`} aria-hidden>
      <div className="orb-drift">
        <div className="orb-cast" />
        <div className="orb-halo" />
        <div className="orb-body" />
        <div className="orb-core" />
        <div className="orb-flare" />
      </div>
    </div>
  );
}
